import { AlertTriangle, Eye, Repeat } from "lucide-react";

const ProblemSection = () => {
  const problems = [
    {
      icon: AlertTriangle,
      title: "Tests limités",
      description: "Le test sur papier ne reflète pas la vraie expérience olfactive"
    },
    {
      icon: Eye,
      title: "Visibilité réduite",
      description: "Difficile d'atteindre votre cible en dehors des points de vente"
    },
    {
      icon: Repeat,
      title: "Manque d'exposition",
      description: "Pas de contact répété avec le consommateur au quotidien"
    }
  ];

  return (
    <section
      id="probleme"
      data-testid="problem-section"
      className="bg-[#0A0A0A] text-white py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Label */}
        <p
          data-testid="problem-label"
          className="font-body text-sm tracking-[0.2em] uppercase text-[#B89F7C] mb-6"
        >
          Les défis du marché
        </p>

        {/* Main Headline */}
        <h2
          data-testid="problem-headline"
          className="font-heading text-4xl sm:text-5xl font-light tracking-tight leading-tight mb-16 max-w-3xl"
        >
          L'industrie du parfum est saturée.
          <br />
          <span className="text-[#B89F7C] italic">Démarquez-vous.</span>
        </h2>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {problems.map((problem) => (
            <div
              key={problem.title}
              data-testid={`problem-card-${problem.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="border-t border-white/20 pt-8"
            >
              <problem.icon
                strokeWidth={1}
                size={32}
                className="text-[#B89F7C] mb-6"
              />
              <h3 className="font-heading text-2xl font-normal mb-4">
                {problem.title}
              </h3>
              <p className="font-body text-base font-light leading-relaxed text-white/70">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
